import React from "react";
import { CircleXIcon, CircleCheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { beforeItems, afterItems } from "../../data/content";
export function BeforeAfter() {
  return <section className="bg-ink px-4 py-16 sm:px-6 sm:py-24" data-id="element-90" data-mp="26k03qkm1qm1i">
      <div className="mx-auto max-w-6xl" data-id="element-91" data-mp="22m2czdcmnrw0">
        <SectionHeading dark eyebrow="From uncertain assessments to a clearer clinical process" title="You Don’t Need More Scattered Information. You Need a Better Way to Organize It." data-id="element-92" data-mp="2zb1or2cf7bsy" />

        <div className="mt-12 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-93" data-mp="2q9u0ld3mbrcl">
          <div className="rounded-3xl bg-white p-6 sm:p-8" data-id="element-94" data-mp="2qc6k3up0y9rr">
            <div className="flex items-center gap-3" data-id="element-95" data-mp="2lah8actz9s2m">
              <span className="rounded-xl bg-danger px-4 py-2 font-display text-lg font-black uppercase tracking-wider text-white" data-id="element-96" data-mp="1eux2ldpghrt3">
                Before
              </span>
              <span className="text-sm font-semibold text-muted" data-id="element-97" data-mp="19yge2iechbfh">Without a framework</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-98" data-mp="1c4gvitnuyb9e">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-ink sm:text-lg" data-id="element-99" data-mp="1c233ktoh5f62">
                  <CircleXIcon className="mt-0.5 h-6 w-6 shrink-0 text-danger" aria-hidden="true" data-id="element-100" data-mp="y70mdae6g3dy" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-white p-6 ring-4 ring-success sm:p-8" data-id="element-101" data-mp="ocs197rh7cpt">
            <div className="flex flex-wrap items-center gap-3" data-id="element-102" data-mp="t6w69lh6lao9">
              <span className="rounded-xl bg-success px-4 py-2 font-display text-lg font-black uppercase tracking-wider text-white" data-id="element-103" data-mp="fezj7vuddqyq">
                After
              </span>
              <span className="text-sm font-semibold text-muted" data-id="element-104" data-mp="5gabgvw6tmw7">With Musculoskeletal Clinical Pathway™</span>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-105" data-mp="ae1zvfxmiqvn">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-base font-medium leading-relaxed text-ink sm:text-lg" data-id="element-106" data-mp="2c4iyu69hx0n0">
                  <CircleCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-success" aria-hidden="true" data-id="element-107" data-mp="27chpot7mjq17" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <SectionCta dark label="I Want a More Structured Assessment Process" data-id="element-108" data-mp="1ye5usezq662y" />
      </div>
    </section>;
}